import { fork } from "redux-saga/effects";
import { dispatchSelf } from "@fdn/profile_store";
import dispatchReview from "../Review/lib/fetch";
import dispatchHighlightReview from "../HightlightReview/lib/fetch";
import dispatchSearchProducts from "../SearchProducts/lib/fetch";
import dispatchSearchSerivces from "../SearchServices/lib/fetch";
import dispatchSearchBrands from "../SearchBrands/lib/fetch";
import dispatchSearchBrandsService from "../searchBrandService/lib/fetch";
import dispatchSearchUsers from "../SearchUsers/lib/fetch";
import dispatchSearchArticles from "../SearchArticles/lib/fetch";
import dispatchCategoryProducts from "../ProductCategory/lib/fetch";
import dispatchBrandList from "../BrandList/lib/fetch";
import dispatchCompleting from "../completing/lib/fetch";
import dispatchWallet from "../AlloWallet/lib/fetch";
import dispatchPoint from "../AlloPoint/lib/fetch";
import dispatchProductMatches from "../ProductMatches/lib/fetch";
import dispatchTopMembers from "../TopMembers/lib/fetch";
import dispatchSearchDefault from "../SearchDefault/lib/fetch";
import dispatchQuickSearch from "../QuickSearch/lib/fetch";
import dispatchSearchResult from "../SearchResult/lib/fetch";
import dispatchListCategory from "../category/lib/fetch";

export default function* rootSaga() {

	yield fork(dispatchSelf);
	yield fork(dispatchReview);
	yield fork(dispatchHighlightReview);
	yield fork(dispatchSearchProducts);
	yield fork(dispatchSearchSerivces);
	yield fork(dispatchSearchBrands);
	yield fork(dispatchSearchBrandsService);
	yield fork(dispatchSearchUsers);
	yield fork(dispatchSearchArticles);
	yield fork(dispatchCategoryProducts);
	yield fork(dispatchBrandList);
	yield fork(dispatchCompleting);
	yield fork(dispatchWallet);
	yield fork(dispatchProductMatches);
	yield fork(dispatchTopMembers);
	yield fork(dispatchPoint);
	yield fork(dispatchSearchDefault);
	yield fork(dispatchQuickSearch);
	yield fork(dispatchSearchResult);
	yield fork(dispatchListCategory);

}
